<template>
  <div id="xinxiufinal">
    <div class="relativeItem">
      <img src="../../assets/xinxiu/xlist.jpg" />
      <img class="banner absoluteItem" src="../../assets/xinxiu/xx(2).png" v-show="!show" />
      <img class="banner absoluteItem" src="../../assets/xinxiu/xx(1).png" v-show="show" />
    </div>
    <!--安全区-->
    <div class="slist list-s">
      <p class="title">
        <span class="s1">用户ID</span>
        <span class="s2">魅力值</span>
        <span class="s3">排名</span>
      </p>

      <ul id="sul" class="relativeItem">
        <li class="flex-box" :class="{dark:index % 2 !== 0}" v-for="(n, index) in list" :key="index" v-show="list.length > 0">
          <p class="p1 flex-box">
            <img :src="n.avatar" />
            <span class="apostrophe">{{ n.nickname }}</span>
          </p>
          <p class="p2">{{ n.charm }}</p>
          <p class="p3">No.{{ index + 1 }}</p>
        </li>
        <p class="blank absoluteItem centerImg" v-show="list.length === 0">暂无上榜</p>
      </ul>
    </div>
    <img src="../../assets/xinxiu/xlist(3).jpg" />
  </div>
</template>

<script>
export default {
  name: "xinxiufinal",
  components: {},
  data() {
    return {
      show: true,
      interval: null,
      list: []
    };
  },
  methods: {
    /**获取列表 */
    getList() {
      let _this = this;
      this.$jsonp(this.$apis("nya"), {}, res => {
        _this.list = res.data.data.ultimately;
      });
    }
  },
  mounted: function() {
    this.$tool.setTitle("新年新星秀主播决赛排行榜");
    this.getList();
    let _this = this;
    this.interval = setInterval(() => {
      _this.show = !_this.show;
    }, 500);
  },
  beforeDestroy: function() {
    this.interval = null;
  },
  watch: {}
};
</script>








<style scoped>
#xinxiufinal {
  background: url("../../assets/xinxiu/xlist(2).jpg") repeat left top;
  background-size: 100%;
}
img {
  display: block;
}
.banner {
  width: 100%;
  top: 12%;
  left: 0;
}
.slist {
  width: 85%;
  margin: 0 auto;
  background: url("../../assets/xinxiu/xx.png") no-repeat left top;
  background-size: 100% 100%;
  color: #fff;
  font-size: 12px;
  border-radius: 3px;
  overflow: hidden;
}
.list-s .title {
  background: rgba(255, 0, 255, 0.3);
}
.title span {
  display: inline-block;
}
.title .s1,
ul .p1 {
  width: 40%;
  padding: 4% 0;
  padding-left: 7%;
}
.title .s2,
ul .p2 {
  width: 40%;
  text-align: center;
}
.title .s3,
ul .p3 {
  width: 20%;
  text-align: center;
}
ul {
  min-height: 260px;
  overflow-y: scroll;
  max-height: 400px;
}
ul img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 3px;
}
ul .p1 {
  align-items: center;
  padding: 2% 0;
  padding-left: 2%;
}
ul .p2,
ul .p3 {
  font-weight: bold;
}
ul .p3 {
  color: #ff00ff;
}
.list-d ul .p3 {
  color: #04cece;
}
li {
  align-items: center;
}
#sul .dark {
  background: rgba(255, 0, 255, 0.3);
}
.blank{
  font-size: 16px;
  color: #fff;
}
</style>
